
import { useEffect, useState } from 'react';

interface StartScreenProps {
  onStart: () => void;
  userCount: number;
}

export default function StartScreen({ onStart, userCount }: StartScreenProps) {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
  }, []);

  return (
    <div className="flex flex-col items-center justify-between min-h-screen bg-[#0f0f0f]">
      {/* Telegram Header */}
      <div className="w-full bg-[#212121] px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#2AABEE] rounded-full flex items-center justify-center">
            <i className="ri-heart-3-fill text-white text-xl"></i>
          </div>
          <div>
            <h1 className="text-white font-semibold text-base">Тайный Фанат</h1>
            <p className="text-[#8E8E93] text-xs">{userCount.toLocaleString()} участников</p>
          </div>
        </div>
        <button className="w-8 h-8 flex items-center justify-center cursor-pointer">
          <i className="ri-more-2-fill text-[#8E8E93] text-xl"></i>
        </button>
      </div>

      <div className={`flex-1 flex flex-col items-center justify-center text-center px-6 transition-all duration-1000 ${animate ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <div className="relative mb-8">
          <div className="w-32 h-32 bg-[#2AABEE] rounded-full flex items-center justify-center shadow-lg">
            <i className="ri-user-heart-fill text-white text-6xl"></i>
          </div>
          <div className="absolute -bottom-2 -right-2 w-12 h-12 bg-[#64D2FF] rounded-full flex items-center justify-center border-4 border-[#0f0f0f]">
            <i className="ri-search-eye-line text-white text-xl"></i>
          </div>
        </div>

        <h2 className="text-2xl font-semibold text-white mb-3 leading-tight">
          Узнай, кто твой<br />тайный фанат
        </h2>

        <p className="text-base text-[#8E8E93] mb-8 max-w-xs leading-relaxed">
          Проанализируем активность вокруг твоего Telegram-профиля и найдём того, кто проявляет особый интерес
        </p>

        <div className="w-full max-w-sm space-y-3 mb-8">
          <div className="bg-[#1C1C1E] rounded-xl p-4 flex items-center gap-3">
            <div className="w-10 h-10 bg-[#2AABEE]/20 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-shield-check-line text-[#2AABEE] text-xl"></i>
            </div>
            <div className="text-left">
              <p className="text-white text-sm font-medium">Полностью безопасно</p>
              <p className="text-[#8E8E93] text-xs">Никто не узнает о проверке</p>
            </div>
          </div>

          <div className="bg-[#1C1C1E] rounded-xl p-4 flex items-center gap-3">
            <div className="w-10 h-10 bg-[#2AABEE]/20 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-flashlight-line text-[#2AABEE] text-xl"></i>
            </div>
            <div className="text-left">
              <p className="text-white text-sm font-medium">Мгновенный результат</p>
              <p className="text-[#8E8E93] text-xs">Анализ займёт 5 секунд</p>
            </div>
          </div>

          <div className="bg-[#1C1C1E] rounded-xl p-4 flex items-center gap-3">
            <div className="w-10 h-10 bg-[#2AABEE]/20 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-user-heart-line text-[#2AABEE] text-xl"></i>
            </div>
            <div className="text-left">
              <p className="text-white text-sm font-medium">Точный анализ</p>
              <p className="text-[#8E8E93] text-xs">{userCount.toLocaleString()} человек уже узнали</p>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full px-4 pb-6">
        <button
          onClick={onStart}
          className="w-full bg-[#2AABEE] text-white font-medium text-base py-4 rounded-xl hover:bg-[#1E96D3] active:bg-[#1A7FB8] transition-colors duration-200 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-search-eye-line text-xl"></i>
          Начать сканирование
        </button>
      </div>
    </div>
  );
}
